import { setDataPinCodes } from "../../actions/pinCodes";
import RequestManager from "../../requests/RequestManager";
import store from "../../store";

export const handleUpdateStatus = async (statusRequest, setState, displayHeaderButtons, setClassification) => {
  const resp = await RequestManager.addRequest(statusRequest);
  store.dispatch(setDataPinCodes(resp.response));
  setState({
    contenidos: (resp.response.pin_parental.status === 1)? true : false,
    pagos: (resp.response.pin_purchase.status ===1)? true : false,
    canales: (resp.response.pin_channel.status === 1)? true : false,
    pin_status: {
      parental: resp.response.pin_parental.status,
      purchase: resp.response.pin_purchase.status,
      channel: resp.response.pin_channel.status
    },

  });

  document.getElementsByName('switch_contenidos')[0].checked = resp.response.pin_parental.status;
  document.getElementsByName('switch_pagos')[0].checked = resp.response.pin_purchase.status;
  document.getElementsByName('switch_canales')[0].checked = resp.response.pin_channel.status;
  displayHeaderButtons();

  if (resp.response.pin_parental.info) {
    const value = resp.response.pin_parental.info.value;
    setClassification(value);
  }
}



// WEBPACK FOOTER //
// ./src/containers/User-Settings/utils.js